"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModules = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const typedi_1 = require("typedi");
function getModules(...modules) {
    return modules.reduce((m, Module) => {
        let name = Module.exportName;
        if (Module === bridge_schema_1.BridgeInterface) {
            name = 'bridge';
        }
        return Object.assign(Object.assign({}, m), { [name]: typedi_1.Container.get(Module) });
    }, {});
}
exports.getModules = getModules;
